import React, { useEffect } from "react";
import { FaGraduationCap, FaPlayCircle, FaBookOpen } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function CoursePurchaseSuccess() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'Success';
  }, []);
  const styles = {
    page: {
      minHeight: "100vh",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      background: "#ffffff", // WHITE background
      padding: "20px",
      textAlign: "center",
      color: "#333",
    },

    iconCircle: {
      width: "120px",
      height: "120px",
      borderRadius: "50%",
      background: "#aaecaa",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "55px",
      color: "#5E77FF",
      boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
      marginBottom: "25px",
      animation: "pop 0.6s ease",
    },

    title: {
      fontSize: "2.5rem",
      fontWeight: 700,
      marginBottom: "10px",
    },

    subtitle: {
      fontSize: "1.2rem",
      opacity: 0.8,
      marginBottom: "30px",
    },

    message: {
      fontSize: "1.1rem",
      maxWidth: "600px",
      margin: "0 auto 35px",
      lineHeight: "1.6",
      color: "#555",
    },

    buttons: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      flexWrap: "wrap",
    },

    btnPrimary: {
      padding: "14px 38px",
      borderRadius: "50px",
      fontSize: "1rem",
      fontWeight: 700,
      background: "linear-gradient(135deg, #5E77FF, #6EE2F5)",
      color: "white",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      transition: "0.3s",
      boxShadow: "0 4px 12px rgba(94,119,255,0.4)",
    },

    btnSecondary: {
      padding: "14px 38px",
      borderRadius: "50px",
      fontSize: "1rem",
      fontWeight: 700,
      background: "#ffffff",
      border: "2px solid #5E77FF",
      color: "#5E77FF",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      transition: "0.3s",
    },
  };

  return (
    <>
      <style>
        {`
          @keyframes pop {
            0% { transform: scale(0.5); opacity: 0 }
            100% { transform: scale(1); opacity: 1 }
          }
        `}
      </style>

      <div style={styles.page}>
        <div style={styles.iconCircle}>
          <FaGraduationCap />
        </div>

        <h1 style={styles.title}>Purchase Successful!</h1>
        <p style={styles.subtitle}>You're now enrolled 🎉</p>

        <p style={styles.message}>
          Your purchase is complete! You can start learning right away
          and continue your journey toward mastering new skills.
        </p>

        <div style={styles.buttons}>
          <button
            style={styles.btnPrimary}
            onMouseOver={(e) => (e.target.style.opacity = "0.85")}
            onMouseOut={(e) => (e.target.style.opacity = "1")}
            onClick={() => navigate("/my-courses")}
          >
            <FaPlayCircle /> Start Learning
          </button>

          <button
            style={styles.btnSecondary}
            onMouseOver={(e) => {
              e.target.style.background = "#5E77FF";
              e.target.style.color = "#fff";
            }}
            onMouseOut={(e) => {
              e.target.style.background = "#fff";
              e.target.style.color = "#5E77FF";
            }}
            onClick={() => navigate("/")}
          >
            <FaBookOpen /> Explore More Courses
          </button>
        </div>
      </div>
    </>
  );
}
